import React from 'react'
import { Col, ModalBody,Row,Button} from 'reactstrap';
import 'animate.css';
import { Dialog } from 'primereact/dialog';




export const ModalPreviewInvoiceGlobal = (props) => {
    
    const { loadingPreviewInvoices, showPreviewInvoicesGlobal, handlePreviewGlobalInvoices,handleCancelGlobal,saveInvoicesGlobal,loadingGlobal } = props;

    return (
        <Dialog 
            visible={showPreviewInvoicesGlobal}
            modal
            onHide={handleCancelGlobal}
            style={{ width: '80vw', maxWidth: '900px', borderRadius: '16px' }}
            headerStyle={{
                background: 'linear-gradient( #bd2130)',
                color: 'white',
                fontWeight: 'bold',
                borderRadius: '12px 12px 0 0'
            }}
            pt={{
                header: { style: { backgroundColor: '#bd2130', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
            header={loadingPreviewInvoices ? null : "Factura Global"} 
            className={`pt-0 custom-dialog-bussine ${loadingPreviewInvoices ? 'no-header' : ''} ${loadingPreviewInvoices ? 'no-footer' : ''}`}  // Condicional para footer
            footer={
            !loadingPreviewInvoices && (
                <div>
                    <Button 
                        disabled={loadingGlobal ? true : false} 
                        outline 
                        color="primary" 
                        onClick={() => saveInvoicesGlobal()}
                    >
                        Aceptar
                    </Button>
                </div>
            )
    }
        >
            <ModalBody>
                {
                    loadingPreviewInvoices && (
                        <>
                            <Row>
                                <Col sm="12" md="12" lg="12" className='text-center'>
                                    <img alt='modal-preview' src={require("../../assets/images/loginHelenLabs/HelenLabs.png")} className='fa-spin' style={{ width: "20%" }} />
                                </Col>
                                <Col sm="12" md="12" lg="12" className='text-center mt-1'>
                                    <p>Cargando ...</p>
                                </Col>
                            </Row>
                        </>
                    )
                }
                {!loadingPreviewInvoices && <Col sm="12" style={{textAlign:"center"}} className='p-l-0  p-r-0' >
                <img alt='modal-preview' src={require("../../assets/images/price/warnig-invoices.svg")}style={{ width: "15%" }} /> <br />
                <label className='f-14 f-w-600 txt-danger pt-1' >Esta seguro que estos nims, se facturaran a público general</label>
                </Col>}
            </ModalBody>  
            
        </Dialog>
            )
        }
